import { apiSlice } from './apiSlice';
const STOREINCOMES_URL = '/api/storeIncomes';

export const storeIncomesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStoreIncomes: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: STOREINCOMES_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['StoreIncomes'],
    }),
    getStoreIncomeDetails: builder.query({
      query: (storeIncomeId) => ({
        url: `${STOREINCOMES_URL}/${storeIncomeId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    createStoreIncome: builder.mutation({
      query: (storeIncomeData) => ({
        url: STOREINCOMES_URL,
        method: 'POST',
        body: storeIncomeData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['StoreIncomes'],
    }),
    updateStoreIncome: builder.mutation({
      query: ({ storeIncomeId, ...data }) => ({
        url: `${STOREINCOMES_URL}/${storeIncomeId}`,
        method: 'PUT',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['StoreIncomes'],
    }),
    uploadStoreIncomeImages: builder.mutation({
      query: (formData) => ({
        url: '/api/upload',
        method: 'POST',
        body: formData,
      }),
    }),
      bulkUpdateStoreIncomes: builder.mutation({
  query: (storeIncomeData) => ({
    url: `${STOREINCOMES_URL}/bulk`, // Adjust this if your backend uses a different route
    method: 'PUT',
    body: storeIncomeData,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  invalidatesTags: ['StoreIncomes'],
}),

    deleteStoreIncome: builder.mutation({
      query: (storeIncomeId) => ({
        url: `${STOREINCOMES_URL}/${storeIncomeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['StoreIncomes'],
    }),
    createReview: builder.mutation({
      query: ({ storeIncomeId, ...data }) => ({
        url: `${STOREINCOMES_URL}/${storeIncomeId}/reviews`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['StoreIncomes'],
    }),
    getTopStoreIncomes: builder.query({
      query: () => `${STOREINCOMES_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGetStoreIncomesQuery,
  useGetStoreIncomeDetailsQuery,
  useCreateStoreIncomeMutation,
  useUpdateStoreIncomeMutation,
  useUploadStoreIncomeImagesMutation,
  useDeleteStoreIncomeMutation,
  useCreateReviewMutation,
  useGetTopStoreIncomesQuery,
  useBulkUpdateStoreIncomesMutation,
  
} = storeIncomesApiSlice;